import type { ReactNode } from 'react'
import { View } from 'react-native'

import { GradientTypography } from '@/src/elements/text/gradient'
import { WatchmanSection } from '@/src/features/watchman/ui/components/watchmanSection/WatchmanSection'
import { AuthenticationRequired } from '@/src/general/components/AuthenticationRequired'
import type { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import { IntentionFormButton } from '../../IntentionsScreen/components/IntentionFormButton'
import { IntentionMarkAsRead } from '../../IntentionsScreen/components/IntentionMarkAsRead'

type TIntentionsPagesCommonsProps = {
  trackingSource: TRACKING_SOURCE
  title?: string
  theme?: string
  showWatchman?: boolean
}

export const IntentionsPagesCommons = ({
  showWatchman = true,
  trackingSource,
  title,
  theme,
}: TIntentionsPagesCommonsProps): ReactNode => {
  return (
    <View className="w-full max-w-[500px] gap-4 self-center">
      {!!title && (
        <GradientTypography
          className="w-full items-center px-4 text-xl font-black xm:py-10 md:text-2xl"
          classNameWrapper="flex"
          colors="primary"
        >
          {title}
        </GradientTypography>
      )}
      <IntentionFormButton theme={theme} />

      <View>
        <IntentionMarkAsRead />
        {showWatchman && (
          <AuthenticationRequired>
            <WatchmanSection trackingSource={trackingSource} theme={theme} />
          </AuthenticationRequired>
        )}
      </View>
    </View>
  )
}
